/**
 * Fusos e idiomas oferecidos na criação/edição de workspace.
 *
 * Lista curta de propósito: o produto é brasileiro e o fuso do workspace é o
 * que define o "dia" de toda métrica (invariante 10). Uma lista de 400 zonas
 * IANA num `<select>` de celular é um convite ao erro.
 * Quem precisar de outra zona: o campo aceita qualquer id IANA válido pelo
 * servidor — aqui só mostramos os que existem na prática.
 */
export interface TimezoneOption {
  id: string;
  label: string;
}

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
export const DEFAULT_LOCALE = 'pt-BR';

export const TIMEZONE_OPTIONS: readonly TimezoneOption[] = [
  { id: 'America/Sao_Paulo', label: 'Brasília (GMT-3) — SP, RJ, MG, Sul, Nordeste' },
  { id: 'America/Manaus', label: 'Manaus (GMT-4) — AM, RR, RO, MT, MS' },
  { id: 'America/Rio_Branco', label: 'Rio Branco (GMT-5) — AC' },
  { id: 'America/Belem', label: 'Belém (GMT-3) — PA, AP' },
  { id: 'America/Fortaleza', label: 'Fortaleza (GMT-3) — CE, PI, MA' },
  { id: 'America/Noronha', label: 'Fernando de Noronha (GMT-2)' },
  { id: 'Europe/Lisbon', label: 'Lisboa (GMT+0/+1)' },
  { id: 'UTC', label: 'UTC (sem fuso)' },
];

export interface LocaleOption {
  id: string;
  label: string;
}

export const LOCALE_OPTIONS: readonly LocaleOption[] = [
  { id: 'pt-BR', label: 'Português (Brasil)' },
  { id: 'pt-PT', label: 'Português (Portugal)' },
  { id: 'en-US', label: 'English (United States)' },
  { id: 'es-ES', label: 'Espanhol' },
];

/** Fuso do navegador, se for um dos oferecidos. Senão, o padrão do produto. */
export function guessTimezone(): string {
  try {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TIMEZONE_OPTIONS.some((option) => option.id === detected) ? detected : DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}
